module.exports = __webpack_public_path__ + "static/media/ApercuAktiv-Thin.a197471c.woff2";